<!--NPS-->
<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">NPS</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <!-- <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
        </span>
      </p> -->

      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>

    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>

    <div class="score-view">
      <div
        v-for="(item, index) in 10"
        :key="index"
        :class="
          index + 1 <= selectedScore
            ? 'score-view-item-active'
            : 'score-view-item-inactive'
        "
      >
        {{ index + 1 }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      images: [],
      selectedScore: -1,
    };
  },
  watch: {
    params: {
      handler(newVal) {
        this.dataObj = newVal.data;
        this.index = newVal.index;

        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");

        console.log(
          "8597604976405760467045769045",
          newVal.data.context,
          newVal.data,
        );

        this.selectedScore = newVal.data.context || -1;

        // this.selectedScore = -1;

        // if (
        //   newVal.answer &&
        //   newVal.answer.answer &&
        //   newVal.answer.answer.length > 0
        // ) {
        //   const context = Number(newVal.answer.answer[0].context);

        //   if (!isNaN(context) && context >= 1 && context <= 10) {
        //     this.selectedScore = context;
        //   }
        // }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.score-view {
  display: flex;
  justify-content: space-between;
  /* padding: 0 25px;
  box-sizing: border-box; */
}

.score-view-item-active {
  width: 29px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #dcdde0;
  background-color: #4a73f8;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.score-view-item-inactive {
  width: 29px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ededed;
  background-color: #f9f9f9;
  color: #2b2f36;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationPreview/EvaluationPreviewNPS.vue